/**
 * @returns 分析弹窗
 */

import React from 'react';
import { CloseOutlined } from '@ant-design/icons';
import classnames from 'classnames';
import './index.less';

function Modal(props) {
    let { title, onClose, width, placement = 'left' } = props;
    return (
        <div
            className={classnames('cs-map-tools-modal', {
                'modal-left': placement === 'right',
            })}
            style={{ width }}
        >
            <div className={classnames('cs-map-tools-modal-title')}>
                <div>{title}</div>
                <CloseOutlined width={16} height={16} onClick={onClose} />
            </div>

            <div className={classnames('cs-map-tools-modal-content')}>{props.children}</div>
        </div>
    );
}

export default Modal;
